import { render, staticRenderFns } from "./CourseBanner.vue?vue&type=template&id=2872b3ec&scoped=true&"
import script from "./CourseBanner.vue?vue&type=script&lang=js&"
export * from "./CourseBanner.vue?vue&type=script&lang=js&"
import style0 from "./CourseBanner.vue?vue&type=style&index=0&id=2872b3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872b3ec",
  null
  
)

export default component.exports